import { render, staticRenderFns } from "./PreparingApp.vue?vue&type=template&id=06c8936d"
import script from "./PreparingApp.vue?vue&type=script&lang=js"
export * from "./PreparingApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports